<div class="chip">
  <p class="chip__label">{{ label }}</p>
</div>
